import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IGetSubmissionToPropResponse,
  IGetTradersDbListResponse,
  IWithdrawalsRequestResponse,
} from "../../api/fundedCompliance/index.types";
import { IGetSearchNotesResponse } from "../../api/compliance/index.types";

export interface IFundedComplianceState {
  accountGroups: {
    data: IGetTradersDbListResponse["data"];
    isLoading: boolean;
  };
  submissionToProp: {
    data: IGetSubmissionToPropResponse["data"]["submissionToPropList"];
    isLoading: boolean;
  };
  withdrawals: {
    data: IWithdrawalsRequestResponse["data"]["withdrawals"];
    isLoading: boolean;
  };
  watchlistNotes: {
    data: IGetSearchNotesResponse["data"];
    isLoading: boolean;
  };
}

const initialState: IFundedComplianceState = {
  accountGroups: {
    data: {
      count: 0,
      rows: [],
    },
    isLoading: false,
  },
  submissionToProp: {
    data: {
      count: 0,
      rows: [],
    },
    isLoading: false,
  },
  withdrawals: {
    data: {
      count: 0,
      rows: [],
    },
    isLoading: false,
  },
  watchlistNotes: {
    data: {
      results: {
        count: 0,
        rows: [],
      },
      updated: { measure_timestamp: "" },
    },
    isLoading: false,
  },
};

const fundedComplianceSlice = createSlice({
  name: "fundedCompliance",
  initialState,
  reducers: {
    // Account Groups
    fetchAccountGroupsRequest: (state) => {
      state.accountGroups.isLoading = true;
    },
    fetchAccountGroupsSuccess: (
      state,
      action: PayloadAction<IGetTradersDbListResponse["data"]>
    ) => {
      state.accountGroups.isLoading = false;
      state.accountGroups.data = action.payload;
    },
    fetchAccountGroupsFailed: (state) => {
      state.accountGroups.isLoading = false;
    },

    // Submission To Prop
    fetchSubmissionToPropRequest: (state) => {
      state.submissionToProp.isLoading = true;
    },
    fetchSubmissionToPropSuccess: (
      state,
      action: PayloadAction<IGetSubmissionToPropResponse["data"]["submissionToPropList"]>
    ) => {
      state.submissionToProp.isLoading = false;
      state.submissionToProp.data = action.payload;
    },
    fetchSubmissionToPropFailed: (state) => {
      state.submissionToProp.isLoading = false;
    },

    // Withdrawals
    fetchWithdrawalsRequest: (state) => {
      state.withdrawals.isLoading = true;
    },
    fetchWithdrawalsSuccess: (
      state,
      action: PayloadAction<IWithdrawalsRequestResponse["data"]>
    ) => {
      state.withdrawals.isLoading = false;
      state.withdrawals.data.count = action.payload.withdrawals.count;
      state.withdrawals.data.rows = action.payload.withdrawals.rows;
    },
    fetchWithdrawalsFailed: (state) => {
      state.withdrawals.isLoading = false;
    },

    // WatchlistNotes
    fetchWatchlistNotesRequest: (state) => {
      state.watchlistNotes.isLoading = true;
    },
    fetchWatchlistNotesSuccess: (state, action: PayloadAction<IGetSearchNotesResponse["data"]>) => {
      state.watchlistNotes.isLoading = false;
      state.watchlistNotes.data = action.payload;
    },
    fetchWatchlistNotesFailed: (state) => {
      state.watchlistNotes.isLoading = false;
    },
  },
});

export const fundedComplianceActions = fundedComplianceSlice.actions;
export default fundedComplianceSlice.reducer;
